import { Injectable } from '@angular/core';
import { Utils } from 'core';
import { MessageService } from '../message/message.service';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  constructor(private messageService: MessageService) {}

  copyToClipboard(text: string, confirmationMessage: string): void {
    Utils.copyToClipboard(text);
    this.messageService.success(confirmationMessage);
  }
}
